<template>
  <cargo-dialog
    ref="queryWindow"
    custom-class="query-window-dialog"
    :visible="visible"
    :title="title"
    width="1100px"
    top="5vh"
    :can-maximize="source==='append'||source==='VoucherList'"
    :can-minimize="source==='append'||source==='VoucherList'"
    :source="source"
    class="grid-view parent-wrapper"
    @close="cancelHandler"
  >
    <tab-query-page
      ref="tabNav"
      :properties="properties"
      :account-set="accountSet"
      :show-total-group="false"
      :voucher-page="2"
      :pre-bank-slip-states="preBankSlipStates"
      :col-settings="{span:8}"
      :is-ext="isExt"
      :filter-charge-for-job="source === 'VoucherList'"
      style="display: flex;flex-grow: 1;"
    />
    <el-form v-if="groupBtnVisible && btnMerge" :inline="true" style="width: 100%; padding-top: 1px; border-top: 1px solid lightgray;">
      <div style="display: flex;flex-direction: row;">
        <div style="flex: 1">
          <div class="el-form-item-wrapper">
            <el-form-item label-width="0" class="custom-textarea">
              <el-input v-model="groupText" no="groupText" type="textarea" :rows="3" resize="none" style="width:930px;" :readonly="true" />
            </el-form-item>
          </div>
        </div>
        <div style="width: 150px;">
          <div class="el-form-item-wrapper">
            <el-form-item>
              <el-button no="Add" @click="addToAutoBtnClickHandler">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
              <el-button no="Empty" @click="clearBtnClickHandler">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper">
            <el-form-item label-width="0">
              <span style="font-weight: normal;font-size: 13px;">{{ itemsAddedLabel }}</span>
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
    <div slot="footer">
      <el-button v-show="groupBtnVisible" no="preGroupBtn" style="width: 70px;" :disabled="processing" @click="preGroupBtnClickHandler">{{ preGroupBtnLabel }}</el-button>
      <el-button v-show="groupBtnVisible" no="CreateCombination" style="width: 70px;" :disabled="processing" @click="groupBtnClickHandler">{{ $t('CargoMsg.Cargo_CreateCombination') }}</el-button>
      <el-button no="Confirm" style="width: 70px;" :disabled="processing" @click="commitHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button no="Cancel" style="width: 70px;" @click="cancelHandler">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </cargo-dialog>
</template>

<script>
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import TabQueryPage from '@/views/cargo/v0/FinanceManage/VoucherMaintenance/TabQueryPage'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'QueryWindow',
  components: { CargoDialog, TabQueryPage },
  props: {
    isExt: { type: Boolean, default: false },
    accountSet: { type: Object }, // 账套
    visible: { type: Boolean, required: true },
    title: { type: String, required: false, default: '生成凭证' },
    source: { type: String, default: '' },
    preBankSlipStates: { type: Array, default: () => [] } // 预收款状态
  },
  data() {
    return {
      processing: false, // 后台处理中
      btnMerge: false,
      groupText: '',
      autoComp: {
        selectedItems: [] // 选中行
      },
      properties: {
        activeTabName: 'batchPage'
      },
      groupReceiptPaymentPrefix: false,
      keys: [],
      chargeKeys: [],
      isReceiptPaymentPrefix: false, // 是否实收付凭证字
      isAr: false, // 支付类型
      receiptPaymentType: -1 // 收付方式
    }
  },
  computed: {
    preGroupBtnLabel() {
      if (this.btnMerge) {
        return this.$t('CargoMsg.Cargo_CancelMerging')
      } else {
        return this.$t('CargoMsg.Cargo_Merge')
      }
    },
    itemsAddedLabel() {
      return this.$t('CargoMsg.Cargo_ItemsAdded').format(this.autoComp.selectedItems.length)
    },
    groupBtnVisible() {
      return this.properties.activeTabName !== 'batchPage'
    }

  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.initConfig()
  },
  methods: {
    // 配置参数
    initConfig() {
      this.groupReceiptPaymentPrefix = Number(cache.config.get('groupReceiptPaymentPrefix')) === 1
    },
    preGroupBtnClickHandler() {
      this.btnMerge = !this.btnMerge
      this.clearBtnClickHandler()
    },
    // 合并生成
    groupBtnClickHandler() {
      this.commitHandler(null)
    },
    commitHandler(event) {
      if (this.properties.activeTabName === 'batchPage') {
        if (!this.validate()) return false
        this.$emit('batchGenerate')
      } else {
        this.keys = []
        this.chargeKeys = []
        if (event !== null) {
          const selections = this.getSelections()
          if (selections.length === 0) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PSRTCV'))
            return
          }
          for (const item of selections) {
            this.keys.push(item.uuid)
            if (item.chargeKeys) {
              this.chargeKeys.push(...item.chargeKeys.split(','))
            }
          }
          if (this.keys.length === 0) return
          this.$emit('commit')
        } else {
          if (this.autoComp.selectedItems.length === 0) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PSRTCV'))
            return
          }
          for (const item of this.autoComp.selectedItems) {
            this.keys.push(item.uuid)
            if (item.chargeKeys) {
              this.chargeKeys.push(...item.chargeKeys.split(','))
            }
          }
          if (this.keys.length === 0) return
          this.isReceiptPaymentPrefix = false
          this.isAr = false
          this.receiptPaymentType = -1
          // CARGO-1774，合并生成凭证后凭证字为记
          const bizDataType = this.bizDataType()
          if (this.groupReceiptPaymentPrefix && (
            bizDataType === FinanceInterfaceConstants.RECEIPT_INTERNAL.code ||
            bizDataType === FinanceInterfaceConstants.PAYMENT_INTERNAL.code ||
            bizDataType === FinanceInterfaceConstants.RECEIPT_FOREGIN.code ||
            bizDataType === FinanceInterfaceConstants.PAYMENT_FOREGIN.code ||
            bizDataType === FinanceInterfaceConstants.RECEIPT_PAYMENT_OFFSET.code ||
            bizDataType === FinanceInterfaceConstants.RECEIPT_PAYMENT.code)) {
            // 是否有不同
            let diffisArOrType = false
            // 支付类型
            const _ar = this.autoComp.selectedItems[0]['ar']
            // 收付方式: 0=现金; 2=银行转账
            const _receiptPaymentType = this.autoComp.selectedItems[0]['type']
            for (const item of this.autoComp.selectedItems) {
              // 支付类型
              if (_ar !== item['ar']) {
                diffisArOrType = true
                break
              }
              // 收付方式
              if (_receiptPaymentType !== item['type']) {
                diffisArOrType = true
                break
              }
            }
            //
            if (diffisArOrType) {
              const self = this
              this.$confirm(this.$t('CargoMsg.Cargo_TPTODIDDYCTMAGV'), this.$t('CargoMsg.Cargo_Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
                cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
                type: 'warning'
              }).then(() => {
                this.isReceiptPaymentPrefix = true
                this.isAr = _ar
                this.receiptPaymentType = _receiptPaymentType
                self.$emit('groupCommit')
              }).catch(() => {})
            } else {
              this.isReceiptPaymentPrefix = true
              this.isAr = _ar
              this.receiptPaymentType = _receiptPaymentType
              this.$emit('groupCommit')
            }
          } else {
            this.$emit('groupCommit')
          }
        }
      }
    },
    addToAutoBtnClickHandler() {
      this.autoComp.selectedItems = this.getSelections()
      this.groupText = this.selectedText()
    },
    selectedText() {
      const bizDataType = this.bizDataType()
      const resultArray = []
      let labelField = ''
      for (const item of this.autoComp.selectedItems) {
        // CARGO-20818，合并生成凭证时，待合并条目显示：不管是否开启ext
        if (true && (bizDataType === FinanceInterfaceConstants.RECEIPT_INTERNAL.code ||
          bizDataType === FinanceInterfaceConstants.PAYMENT_INTERNAL.code ||
          bizDataType === FinanceInterfaceConstants.RECEIPT_FOREGIN.code ||
          bizDataType === FinanceInterfaceConstants.PAYMENT_FOREGIN.code ||
          bizDataType === FinanceInterfaceConstants.RECEIPT_PAYMENT.code ||
          bizDataType === FinanceInterfaceConstants.RECEIPT_PAYMENT_OFFSET.code ||
          bizDataType === FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT.code ||
          bizDataType === FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT_CLEAR.code)) {
          labelField = 'actualAmountNo'
        }
        if (true && (bizDataType === FinanceInterfaceConstants.BILLING_OVERSEA.code ||
          bizDataType === FinanceInterfaceConstants.BILLING_RECEIVABLE.code ||
          bizDataType === FinanceInterfaceConstants.BILLING_PAYABLE.code)) {
          labelField = 'billingNo'
        }
        if (true && (
          bizDataType === FinanceInterfaceConstants.INVOICE_RECEIVABLE.code ||
          bizDataType === FinanceInterfaceConstants.INVOICE_RECEIVABLE_PAYABLE.code ||
          bizDataType === FinanceInterfaceConstants.INVOICE_PAYABLE_OFFSET.code ||
          bizDataType === FinanceInterfaceConstants.INVOICE_PAYABLE.code)) {
          labelField = 'invoiceNo'
        }
        if (true && bizDataType === FinanceInterfaceConstants.BIZ_COST.code) {
          labelField = 'jobNo'
        }
        if (true && bizDataType === FinanceInterfaceConstants.BILLPAYMENT.code) {
          labelField = 'billPaymentNo'
        }
        if (!StrUtils.isEmpty(labelField)) {
          if (!StrUtils.isEmpty(item[labelField])) resultArray.push(item[labelField])
        }
      }
      return resultArray.length > 0 ? resultArray.toString() : ''
    },
    clearBtnClickHandler() {
      this.autoComp.selectedItems = []
      this.groupText = ''
    },
    cancelHandler() {
      this.$emit('close')
      if (this.source === 'append' || this.source === 'VoucherList') {
        if (this.destroySelf) {
          this.destroySelf()
        }
      }
    },
    selectedKeys() {
      return this.keys
    },
    selectedChargeKeys() {
      return this.properties.activeTabName === 'jobQuery' ? this.chargeKeys : null
    },
    bizDataType() {
      return this.$refs.tabNav.bizDataType()
    },
    // 生成凭证记录
    getSelections() {
      return this.$refs.tabNav.getSelections()
    },
    // 合并生成凭证记录
    selectedItems() {
      return this.autoComp.selectedItems
    },
    isRedPunch() {
      return this.$refs.tabNav.isRedPunch()
    },
    extraConditions() {
      return this.$refs.tabNav.extraConditions()
    },
    bizTypes() {
      return this.$refs.tabNav.bizTypes()
    },
    startDate() {
      return this.$refs.tabNav.startDate()
    },
    endDate() {
      return this.$refs.tabNav.endDate()
    },
    isExport() {
      return this.$refs.tabNav.isExport()
    },
    validate() {
      return this.$refs.tabNav.validate()
    },
    resetRowData() {
      this.btnMerge = false
      this.keys = []
      this.chargeKeys = []
      this.clearBtnClickHandler()
      if (this.$refs.tabNav) this.$refs.tabNav.resetRowData()
    },
    reInitConfig() {
      this.initConfig()
      if (this.$refs.tabNav) this.$refs.tabNav.initConfig()
    }
  }

}
</script>

<style lang="scss">
.query-window-dialog {
  .el-dialog__body{
    padding: 0px 5px 0px;
  }
  .el-dialog__footer{
    padding: 5px;
  }
  .el-form-item {
    margin:0 !important;
  }
}
</style>
